export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    direction: 'ltr'
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    direction: 'ltr'
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    direction: 'ltr'
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    direction: 'ltr'
  },
  {
    code: 'fil',
    name: 'Filipino',
    nativeName: 'Filipino',
    flag: '🇵🇭',
    direction: 'ltr'
  }
];

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_NAMESPACE = 'common';
export const NAMESPACES = [
  'common',
  'navbar',
  'footer',
  'home',
  'pricing',
  'features',
  'about',
  'security',
  'partners',
  'privacy',
  'terms',
  'contact',
  'waitingList'
];
